import * as React from 'react';
import debounce from 'lodash.debounce'
import Box from '@mui/material/Box';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TextField from "@mui/material/TextField";
import Skeleton from '@mui/material/Skeleton';
import { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from "react-redux";
import SearchIcon from '@mui/icons-material/Search';
import { Grid, InputAdornment, Stack } from '@mui/material';
import SearchListGrid from '../searchListGrid/SearchListGrid';
import {
    deleteTargetPendingSelector,
    deleteTargetSelector,
    getTargetListPendingSelector,
    getTargetListSelector,
    getTargetSelector
} from "../../../store/dataTarget/selectors";
import {
    deleteTargetReq,
    fetchTargetDetailsReq,
    fetchTargetListReq,
} from "../../../store/dataTarget/actions";
import { IDataTarget, IDataTargetDetails, ITargetListParams } from '../../../store/dataTarget/types';
import { HeadCell, Order } from '../tableGrid/types';
import * as constants from '../../../constants/_pickerValues'
import EnhancedTable from '../tableGrid/tableGrid';
import EnhancedTableToolbar from '../tableGrid/tableToolbar';
import EnhancedTableHead from '../tableGrid/tableHead';
import Row from '../tableGrid/tableRow';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { getProfileDataSelector } from '../../../store/auth/selectors';
import CustomizedDialogs from '../../atoms/modal/customizedDialogs';
import {SEARCH_DEBOUNCE_TIME_MILLIS} from "../../../constants/common";


// settings data

const headCells: HeadCell[] = [
    {
        id: 'description',
        numeric: false,
        disablePadding: false,
        label: 'Description',
        width: "150px",
    },
    {
        id: 'name',
        numeric: false,
        disablePadding: false,
        label: 'Name',
        width: "230px",
    },
    {
        id: 'dbType',
        numeric: false,
        disablePadding: false,
        label: 'DbType',
        width: "180px",
    },
    {
        id: 'layerType',
        numeric: false,
        disablePadding: false,
        label: 'Type',
        width: "100px",
    },
    {
        id: 'owner',
        numeric: false,
        disablePadding: false,
        label: 'Owner',
        width: "100px",
    },

];

const filterCells: string[] = [
    'layerType', 'owner',
]


// end

const descendingComparator = (a: IDataTarget, b: IDataTarget, orderBy: keyof IDataTarget) => {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

const getComparator = (order: Order, orderBy: keyof IDataTarget): (
    a: IDataTarget,
    b: IDataTarget,
) => number => {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
};


export type TargetExplorerProps = {
    personal?: boolean;
    isAdmin: boolean;
}


const TargetExplorer = (props: TargetExplorerProps) => {

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [dataRows, setDataRows] = useState<IDataTarget[]>([]);
    const [totalRows, setTotalRows] = useState(0);
    const [order, setOrder] = useState<Order>("asc");
    const [orderBy, setOrderBy] = useState<keyof IDataTarget>("description");
    const [rowDetails, setRowDetails] = useState<IDataTargetDetails[]>([]);
    const [selected, setSelected] = useState<readonly string[]>([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [personalView, setPersonalView] = useState(props.personal === undefined ? false : props.personal);
    const [mail, setMail] = useState("")
    const [open, setOpen] = useState(false);
    const [rowID, setRowID] = useState(0);
    const [rowName, setRowName] = useState('');
    const selectable: string = "no";
    const allSelectable: boolean = false;

    // Filters-related
    const [layerTypes, setLayerTypes] = useState<string[]>([]);
    const [owners, setOwners] = useState<string[]>([]);
    const [endpoints, setEndpoints] = useState<string[]>([]);
    const [filters, setFilters] = useState<string[]>([]);
    const [openFilters, setOpenFilters] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    // target list   
    const targetList = useSelector(getTargetListSelector);
    const loadingTargetList = useSelector(getTargetListPendingSelector)
    const deletePending = useSelector(deleteTargetPendingSelector)
    const deleteTargetStatus = useSelector(deleteTargetSelector)
    const [deletedIds, setDeletedIds] = useState<string[]>([]);
    const [deletedIdLoading, setDeletedIdLoading] = useState('')

    // current user
    const userProfile = useSelector(getProfileDataSelector);


    

    // target details
    const targetDetail = useSelector(getTargetSelector);
    useEffect(() => {
        if (!userProfile) {
            return;
        }

        if (personalView) {
            setOwners([userProfile['userPrincipalName']]);
        } else if (owners.length > 0) {
            setOwners([])
        }
    }, [userProfile])

    useEffect(() => {
        if (userProfile) {
            setMail(userProfile.mail)
        }
    }, [userProfile]);

    const params: ITargetListParams = {
        skip: page * rowsPerPage,
        top: rowsPerPage,
        count: true,
        search: searchTerm,
        layerType: layerTypes,
        owner: owners,
        endpoint: endpoints,
        orderby: `${orderBy} ${order}`
    };


   
    useEffect(() => {
        if (personalView && owners.length < 1) {
            return;
        }
        window.scrollTo(0, 0)
        dispatch(fetchTargetListReq(params));
    }, [page, rowsPerPage, searchTerm, owners, orderBy, order, filters, layerTypes, endpoints]);

    useEffect(() => {
        let data: IDataTarget[] = targetList.targets;

        // const getdbType = (item: any) => {
        //     switch (item) {
        //         case 'LOAD_REDSHIFT':
        //             return "Redshift";
        //         case 'LOAD_S3':
        //             return "S3";
        //         case 'LOAD_ADLS':
        //             return "ADLS";
        //         case 'LOAD_MSSQL':
        //             return "MSSQL";
        //         case 'LOAD_ORACLE':
        //             return "ORACLE";
        //         case 'LOAD_POSTGRES':
        //             return "Postgres";
        //         case 'LOAD_SQLDW':
        //             return "SQLDW";
        //         default:
        //             return "NA";
        //     }
        // }


        // if (data && data.length > 0) {
        //     const newData = data.map((item: any, index: number) => {
        //         return { ...item, dbType: getdbType(item.layerType), id: index };
        //     })
        //     setDataRows(newData);
        // }
        // else {
        //     setDataRows(data);
        // }

        setDataRows(data);

        setTotalRows(targetList.count);
    }, [targetList]);

    useEffect(() => {

        let isDetailExists = false;
        if (targetDetail) {
            isDetailExists = rowDetails.filter((x) => x && x.targetId === targetDetail!.targetId).length > 0;
            if (!isDetailExists) {
                setRowDetails([...rowDetails, targetDetail!]);
            }
        }

    }, [targetDetail, rowDetails]);

    // table related events 

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleRequestSort = (
        event: React.MouseEvent<unknown>,
        property: string,
    ) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property as keyof IDataTarget);
    };

    const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            const newSelecteds = dataRows.map((n: { name: any; }) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const deleteAllClick = () => {
        setSelected([]);
    }

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPage(0);
        setSearchTerm(e.target.value);

    }

    const handleSearchDebounce = useMemo(() => {
        return debounce(handleSearch, SEARCH_DEBOUNCE_TIME_MILLIS);
    }, []);


    const searchEl = () => {
        return (
            <TextField
                id="target-search"
                label="Search Targets"
                type="search"
                fullWidth={true}
                onChange={handleSearchDebounce}
                InputProps={{
                    startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
                }}
            />
        );
    };

    const handleExpand = (row: IDataTarget) => {
        let isExist = rowDetails.find((x) => x && x.targetId === row.targetId);

        if (!isExist) {
            // dispatch get target details action
            dispatch(fetchTargetDetailsReq(row.targetId));
        }
    }
    

    const handleTargetView = (row: IDataTarget,event:React.MouseEvent<HTMLButtonElement>) => {
        const url = `/ViewDataTarget/${row.targetId}`
        if(event.ctrlKey){
            window.open(url,'_blank')
        }
        else{
        navigate(url);
    }
    }

    const handleTargetEdit = (row: IDataTarget,event:React.MouseEvent<HTMLButtonElement>) => {
        const url = `/EditDataTarget/${row.targetId}`
        if (props.isAdmin || row.owner.toLowerCase() === userProfile?.mail.toLowerCase()) {
            if(event.ctrlKey){
                window.open(url,'_blank')
            }
            else{
            navigate(url);}
        }
    }

    const handleTargetDelete = () => {
        setOpen(false);
        dispatch(deleteTargetReq(rowID));
        setDeletedIds(x => [...x, rowID.toString()]);
        setDeletedIdLoading(rowID.toString())
    }

    const confirmTargetDelete = (row: IDataTarget) => {
        setOpen(true);
        setRowID(row.targetId);
        setRowName(row.name);
    }

    const handleClose = () => {
        setOpen(false);
    }

    const filterResults = (event: React.MouseEvent<HTMLButtonElement>, filters: string[]) => {

        let newLayers: string[] = [];
        let newOwners: string[] = personalView ? [userProfile['userPrincipalName']] : [];
        let newEndpoints: string[] = [];

        filters.forEach(item => {
            let filter: string[] = item.split(": ");
            switch (filter[0]) {
                case 'owner':
                    newOwners.push(filter[1]);
                    setOwners(newOwners);
                    params.owner = newOwners;
                    break;
                case 'layerType':
                    newLayers.push(filter[1]);
                    setLayerTypes(newLayers);
                    params.layerType = newLayers;
                    break;
                case 'endpoint':
                    newEndpoints.push(filter[1]);
                    setEndpoints(newEndpoints);
                    params.endpoint = newEndpoints;
                    break;
                default:
                    break;
            }
        });

        setFilters(filters);
        setOpenFilters(true);
        setPage(0);
    }

    const refreshPage = () => {

        setLayerTypes([]);
        params.layerType = [];

        personalView ? setOwners([userProfile['userPrincipalName']]) : setOwners([]);
        params.owner = personalView ? [userProfile['userPrincipalName']] : [];

        setEndpoints([]);
        params.endpoint = [];

        setFilters([]);
        setOpenFilters(false);

        setOrder('asc')
        setOrderBy("description")
    }

    const tableToolBar = () => {
        return (
            <EnhancedTableToolbar numSelected={selected.length} title={'Data Targets'} headCells={headCells} filterCells={filterCells} deleteAll={deleteAllClick}
                filterResults={filterResults} refreshPage={refreshPage} personal={personalView} currentFilters={filters} openToolbar={openFilters} />
        );
    }

    const tableHeader = () => {
        return (
            <EnhancedTableHead
                headCells={headCells}
                numSelected={selected.length}
                selectable={allSelectable}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={totalRows}
            />
        );
    }


    const filterOwner = (owner: string) => {

        if (owner.toLowerCase() === mail.toLowerCase()) {
            return true
        }
        else return false
    };

    const isSelected = (name: string) => selected.indexOf(name) !== -1;

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - totalRows) : 0;

    const tableRows = () => {

        return (
            <>
                {dataRows?.length > 0 && dataRows.slice().sort(getComparator(order, orderBy))
                    .map((row: IDataTarget, index: number) => {
                        const isItemSelected = isSelected(row.name);
                        const checkOwner = (row.owner !== null ? filterOwner(row.owner) : false);
                        return (
                            <Row row={row}
                                key={row.name}
                                headCells={headCells}
                                selectable={selectable}
                                canEdit={props.isAdmin || checkOwner}
                                canView={true}
                                canDelete={props.isAdmin || checkOwner}
                                canExpand={true}
                                isItemSelected={isItemSelected}
                                handleClick={undefined}
                                handleExpand={handleExpand}
                                handleView={handleTargetView}
                                handleEdit={handleTargetEdit}
                                handleDelete={confirmTargetDelete}
                                loadingIcon={deletePending}
                                deleteId={deleteTargetStatus?.success}
                                deletedRows={deletedIds}
                                deletedIdLoading={deletedIdLoading}
                            >

                                {rowDetails.length > 0 &&
                                    <Box className="expand-details" sx={{ margin: 1 }}>

                                        <Grid container spacing={3}>
                                            <Grid item xs={6}>
                                                <div><span className="title">Name : </span><span>{row.name ?? "None"}</span></div>
                                                <div><span className="title">Description : </span><span>{row.description ?? "None"}</span></div>
                                                <div><span className="title">DB Type : </span><span>{row.dbType ?? "None"}</span></div>
                                                <div><span className="title">Owner : </span><span>{row.owner ?? "None"}</span></div>


                                            </Grid>
                                            <Grid item xs={6}>
                                                <div><span className="title">Cost Centre : </span><span>{row.costCentre ?? "None"}</span></div>
                                                <div><span className="title">Project Code : </span><span>{row.projectCode ?? "None"}</span></div>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                }
                            </Row>
                        );
                    })}
                {emptyRows > 0 && emptyRows < 10 && (
                    <TableRow
                        style={{
                            height: (53) * emptyRows,
                        }}
                    >
                        <TableCell colSpan={6}>There are no targets available.</TableCell>
                    </TableRow>
                )}
                {dataRows?.length < 1 && (
                    <TableRow
                        style={{
                            height: (53) * emptyRows,
                        }}
                    >
                        <TableCell colSpan={6}>There are no targets available.</TableCell>
                    </TableRow>
                )}
            </>
        );
    }


    const listGrid = () => {

        return (
            <>
                {/* adding skeleton screen on loading */}
                {loadingTargetList ?
                    <Grid container width="100%">
                        <Grid item xs={12}>
                            <Skeleton animation="wave" height={60} />
                        </Grid>
                        <Grid item xs={12}>
                            <Skeleton animation="wave" height={60} />
                        </Grid>
                        <Grid item xs={12}>
                            <Skeleton animation="wave" height={60} />
                        </Grid>
                        <Grid item xs={12}>
                            <Skeleton animation="wave" height={60} />
                        </Grid>
                        <Grid item xs={12}>
                            <Skeleton animation="wave" height={60} />
                        </Grid>
                        <Grid item xs={12}>
                            <Skeleton animation="wave" height={60} />
                        </Grid>
                        <Grid item xs={12}>
                            <Skeleton animation="wave" height={60} />
                        </Grid>
                        <Grid item xs={12}>
                            <Skeleton animation="wave" height={60} />
                        </Grid>
                    </Grid>

                    :
                    <EnhancedTable
                        totalRows={totalRows}
                        tableToolBar={tableToolBar()}
                        tableHeader={tableHeader()}
                        tableRows={tableRows()}
                        pagination={true}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        handleChangePage={handleChangePage}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                }
            </>
        );
    }

    return (
        <>
            <SearchListGrid searchEl={searchEl()} children={listGrid()} />

            <CustomizedDialogs
                dialogHeight=''
                modalSize="md"
                key="override"
                modalTitle="Delete Confirmation"
                isOpen={open}
                onClose={handleClose}
                footerAction={
                    <Stack direction="row" spacing={2}>
                        <Button id="65871373-efab-4c06-9f0c-859c94a01a3a"
                            color="primary"
                            onClick={handleTargetDelete}
                            autoFocus
                        >
                            Yes
                        </Button>
                        <Button id="5c0e317b-829d-457c-96a8-123715616246" color="primary" onClick={handleClose}>
                            No
                        </Button>
                    </Stack>
                }
            >
                <>
                    Are you sure you want to delete {rowName}?
                </>
            </CustomizedDialogs>
        </>
    );

};

export default TargetExplorer;